import { Text } from '@chakra-ui/react'
import { IoReloadCircleOutline } from 'react-icons/io5'
import { FlexRow } from './flex'

export const NewVersionBanner = () => {
  return (
    <FlexRow borderRadius={'4px'} bg='#F59E0B' px={'8px'} py={'4px'} gap='4px'>
      <IoReloadCircleOutline size={20} color={'white'} />
      <Text color='white' fontSize={'13px'} fontWeight={500}>
        Update verfügbar: Seite aktualisieren
      </Text>
    </FlexRow>
  )
}
